/**
 * Schema of Area de Risco
 */
import {$, datetime, InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import AreaDeRisco from '@/model/resource/AreaDeRisco'

export default (model: AreaDeRisco): Schema => ({
  cnpj: {
    content: model.responsavel ? $.filter.cpfOrCnpj(model.responsavel.cnpj) : '-',
  },
  dataCadastro: {
    content: datetime(model.dataCadastro),
  },
  cepInicial: {
    content: String(model.cepInicial),
    input: InputType.CEP,
    meta: {
      mask: '#####-###',
      required: true,
      maxlength: '8',
    },
  },
  cepFinal: {
    content: String(model.cepFinal),
    input: InputType.CEP,
    meta: {
      mask: '#####-###',
      required: true,
      maxlength: '8',
    },
  },
  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },
  notificarNoApp: {
    content: bool(model.notificarNoApp),
    input: InputType.CHECKBOX,
  },
  notificarNoPainel: {
    content: bool(model.notificarNoPainel),
    input: InputType.CHECKBOX,
  },
})
